import mitt from 'mitt';
import { authUtilityLoader, authWebComponentURL } from '@consumer/auth-utility-loader';

interface AuthModules {
  isUserSignedIn: () => Promise<boolean>;
  getCognitoIdToken: () => Promise<string>;
  getCognitoAccessToken: () => Promise<string>;
  showAuthModal: () => void;
  signOut: () => void;
  getConsumerId: () => Promise<string>;
}

export const authComponentsUrl = authWebComponentURL();

export const importAuthUtils = async () => {
  globalThis.caiEventBus ||= mitt();
  const { isUserSignedIn, signOut, getCognitoIdToken, getCognitoAccessToken, showAuthModal, getConsumerId } = (await authUtilityLoader()) as AuthModules;
  globalThis.PSX_AUTH = {
    isUserSignedIn: isUserSignedIn,
    getCognitoIdToken: getCognitoIdToken,
    getCognitoAccessToken: getCognitoAccessToken,
    showAuthModal: showAuthModal,
    signOut: signOut,
    getConsumerId: getConsumerId,
  };
};

export const authComponentDefined = async () => {
  return customElements.whenDefined('cai-authentication');
};
